import React from 'react';

import SidePanelCard from './sidePanelCard';

import euMeditoImage from '../images/sidePanel/euMedito.png';
import msfImage from '../images/sidePanel/msf.png';

import styles from '../styles/components/sidePanel.module.scss';

const SidePanel = () => (
  <div className={styles.container}>
    <SidePanelCard
      titleId="sidePanel.estimulacionNeural.title"
      textId="sidePanel.estimulacionNeural.text"
      image={msfImage}
      altTextId="sidePanel.estimulacionNeural.altText"
      externalLink="https://www.manossinfronteras.org/"
    />
    <SidePanelCard
      titleId="sidePanel.yoMedito.title"
      textId="sidePanel.yoMedito.text"
      image={euMeditoImage}
      altTextId="sidePanel.yoMedito.altText"
      externalLink="https://www.eumedito.org/"
    />
  </div>
);

export default SidePanel;
